/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OverriddenCapabilitiesWithServiceTypeSpec } from './overriddenCapabilitiesWithServiceTypeSpec';


export interface CapabilitiesResponseWithOrgIdServiceType { 
    capabilities_by_service_type: Array<OverriddenCapabilitiesWithServiceTypeSpec>;
    /**
     * UUID of the org.
     */
    org_id: string;
}

